(() => {
  const ORDER = [
    'galaxy-heroes-deluxe-box',
    'glowplush-collector-edition',
    'legendary-glowplush-vault',
    'complete-keychain-set',
    'glow-bunny-keychain',
    'goku-galaxy-keychain',
    'sasuke-galaxy-keychain',
    'frieza-galaxy',
  ];

  if (location.pathname === '/collections/all') {
    location.replace('/collections/catalog' + location.search + location.hash);
    return;
  }

  const rank = (handle) => {
    if (!handle) return 999;
    const exact = ORDER.indexOf(handle);
    if (exact !== -1) return exact;
    if (handle.includes('complete') || handle.includes('keychain-set') || handle.includes('bundle')) return 0;
    if (handle.includes('bunny')) return 1;
    if (handle.includes('goku')) return 2;
    if (handle.includes('sasuke')) return 3;
    if (handle.includes('frieza')) return 4;
    return 999;
  };

  const handleFrom = (el) => {
    const a = el.querySelector('a[href*="/products/"]');
    if (!a) return null;
    const match = a.getAttribute('href').match(/\/products\/([a-z0-9-]+)/i);
    return match ? match[1] : null;
  };

  const reorderChildren = (container, items) => {
    if (!container || items.length < 2) return;
    const sorted = items.slice().sort((a, b) => rank(handleFrom(a)) - rank(handleFrom(b)));
    let changed = false;
    for (let i = 0; i < sorted.length; i++) {
      if (sorted[i] !== items[i]) {
        changed = true;
        break;
      }
    }
    if (!changed) return;
    sorted.forEach((el) => container.appendChild(el));
  };

  const run = () => {
    document.querySelectorAll('.product-grid, ul.product-grid').forEach((grid) => {
      const items = [...grid.children].filter((el) => el.matches('li, .product-grid__item'));
      reorderChildren(grid, items);
    });

    document.querySelectorAll('[data-testid="product-list"]').forEach((section) => {
      const list =
        section.querySelector('.resource-list__list, .resource-list, [class*="resource-list"]') ||
        section;
      const items = [...list.querySelectorAll(':scope > .resource-list__item, :scope > *')].filter(
        (el) => el.querySelector('a[href*="/products/"]')
      );
      reorderChildren(list, items);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();
